module.exports = __webpack_public_path__ + "static/media/mater-private-network.43281cd8.jpg";